var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgEditorBackgroundColor = function SvgEditorBackgroundColor(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9.918 12.24 7.747-5.39 1.18 1.297-6.094 7.207zm-2.33.412 4.535 4.983a.935.935 0 0 0 1.395-.09l7.451-8.814a.91.91 0 0 0 .022-1.198l-2.513-2.761a.91.91 0 0 0-1.195-.091l-9.474 6.59a.935.935 0 0 0-.222 1.381m-4.794 5.876 5.617.972 1.48-1.346-3.03-3.328z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgEditorBackgroundColor);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/editor_background_color.c08ec0a2079b44990d7c0ce7a280a399.svg";